import { render, staticRenderFns } from "./SmsBroadcastRecipientTooltip.vue?vue&type=template&id=2a8e984f&scoped=true"
import script from "./SmsBroadcastRecipientTooltip.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastRecipientTooltip.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastRecipientTooltip.vue?vue&type=style&index=0&id=2a8e984f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e984f",
  null
  
)

export default component.exports